import * as THREE from "three";

/**
 * 每帧共享状态（模块级，避免触发 React 重渲染）。
 *
 * 浮动原点（ADR-0003）：所有天体的“绝对显示坐标”保存在 float64（JS number）里，
 * 提交给 GPU 的对象位置一律是 绝对坐标 − origin（origin = 相机目标）。这样不论缩放到多近，
 * 送进 GPU 的数值都很小、float32 精度足够，地月尺度的抖动消失。
 */
export const frame = {
  /** 模式插值：0 = 模型模式，1 = 真实比例。 */
  m: 0,
  /** 浮动原点（= 相机目标，绝对显示坐标，float64）。 */
  origin: new THREE.Vector3(),
  /** 相机到目标的距离（场景单位）。 */
  dist: 340,
  /** 目标深度处每个场景单位对应的屏幕像素。 */
  pxPerUnit: 1,
  /** 太阳相对原点的位置（用于光源与着色器 uniform）。 */
  sunRel: new THREE.Vector3(),
};
export const sunRelUniform = { value: new THREE.Vector3() };
